module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.22ab03a6.ttf";